/*
 * @Author: your name
 * @Date: 2020-08-17 11:19:55
 * @LastEditTime: 2020-08-26 16:13:41
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /backyard-ms/src/api/common.js
 */
import { axiosRequest } from '@/util/axios-request'

export const apiUpload = data => {
  return axiosRequest({
    // url: '/sys/tool/upload_url',
    url: '/app/tool/upload_url',
    data
  })
}

// 获取图片验证码
export const getImgCode = data => {
  return axiosRequest({
    url: '/auth/sms/captcha',
    errorMessage: true,
    data
  })
}
// 获取短信验证码
export const getShortCode = data => {
  return axiosRequest({
    url: '/auth/sms/send',
    errorMessage: true,
    data
  })
}
// 获取部门列表
export const getDepartmentList = data => {
  return axiosRequest({
    url: '/web/Organization/departmentList',
    data
  })
}
// 获取公司信息
export const getCompanyInfo = data => {
  return axiosRequest({
    url: '/web/company/info',
    method: 'get',
    params: data
  })
}
// 通用部门列表
export const getCommonDepList = params => {
  return axiosRequest({
    url: '/web/Organization/commonDeptList',
    params: params
  })
}
// 人员查询（通用插件使用）
export const getCommonDepStaff = params => {
  return axiosRequest({
    url: '/web/Organization/commonSearchDeptStaff',
    params: params
  })
}
export const uploadFn = (url, data) =>
  axiosRequest({
    url,
    data
  })

export const currentSession = url =>
  axiosRequest({
    url: '/auth/user/currentSession'
  })

/**
 * 根据员工ID组查询一组员工信息 用于员工选择组件
 * @param { Array } params 员工id数组
 * @returns
 */
export const getStaffInfoByUserids = data => {
  return axiosRequest({
    url: '/web/staff/getStaffInfoByUserids',
    data
  })
}
